import { Injectable } from '@angular/core';
import { fetchAuthSession, getCurrentUser, signOut } from 'aws-amplify/auth';

import type { AuthSession, GetCurrentUserOutput } from 'aws-amplify/auth';

/**
 * Amplify 認証 SDK のラッパー。store / interceptor / event listener から
 * SDK を直接呼ばず本サービス経由とすることで、SDK 直依存を境界に閉じる。
 * AmplifyAuthenticator コンポーネントは UI ライブラリ側で SDK を使うため対象外。
 */
@Injectable({ providedIn: 'root' })
export class AuthService {
  /** tokens が undefined の場合は未認証状態を示す。 */
  public fetchSession(): Promise<AuthSession> {
    return fetchAuthSession();
  }

  public getCurrentUser(): Promise<GetCurrentUserOutput> {
    return getCurrentUser();
  }

  public signOut(): Promise<void> {
    return signOut();
  }
}
